
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/video-dialog.3c36b5df3083.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/video-dialog.3c36b5df3083.js";